/* assets/age-verification.js */

document.addEventListener("DOMContentLoaded", function () {
  // Check if the user has previously verified their age (e.g., based on cookies).
  const ageVerificationCookie = document.cookie.replace(/(?:(?:^|.*;\s*)ageVerified\s*=\s*([^;]*).*$)|^.*$/, "$1");
  const ageVerificationRequired = ageVerificationCookie !== "true";

  // Get the ageVerificationPopup element
  const ageVerificationPopup = document.getElementById("ageVerificationPopup");

  // Function to hide the popup
  function hidePopup() {
    ageVerificationPopup.style.display = "none";
    // Set a cookie to remember that the user is verified
    document.cookie = "ageVerified=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/";
  }

  // Check if age verification is necessary (e.g., based on cookies).
  if (ageVerificationRequired) {
    setTimeout(function () {
      ageVerificationPopup.style.display = "block";
    }, 5000); // Show the popup after a 5-second delay
  }

  // Event handlers for buttons
  const yesButton = document.querySelector(".yes-button");
  const noButton = document.querySelector(".no-button");

  yesButton.addEventListener("click", function () {
    hidePopup();
    // Handle the case where the user is verified (e.g., set a cookie).
  });

  noButton.addEventListener("click", function () {
    // Handle the case where the user is not verified (e.g., redirect).
  });
});
